// Landing page

import Navbar from "../../components/layout/Navbar";
import HeroSection from "./components/HeroSection";
import InvitationMessageSection from "./components/InvitationMessageSection";
import ScheduleSection from "./components/ScheduleSection";
import ReconciliationBallSection from "./components/ReconciliationBallSection";
import OfficialsSection from "./components/OfficialsSection";
import OutgoingPresidentQuoteSection from "./components/OutgoingPresidentQuoteSection";
// import RegistrationSection from "./components/RegistrationSection";
import DownloadsSection from "./components/DownloadsSection";
import LandingFooter from "./components/LandingFooter";

export default function LandingPage() {
  return (
    <main className="min-h-screen bg-twilight-indigo-950 text-white">
      <Navbar />
      <HeroSection />
      <InvitationMessageSection />
      <ScheduleSection />
      <ReconciliationBallSection />
      <OfficialsSection />
      <OutgoingPresidentQuoteSection />
      {/* <RegistrationSection /> */}
      <DownloadsSection />
      <LandingFooter />
    </main>
  );
}